import React, { useEffect, useRef, useState } from 'react';
import './../i18n';
import { useTranslation } from 'react-i18next';

function parseJwt(token) {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
      atob(base64).split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export default function UserMenu({ isLoggedIn, onLoginClick, onLogout, onChangePassword }) {
  const { t } = useTranslation(); // <-- FIX: Added this line to define the 't' function
  const [open, setOpen] = useState(false);
  const [username, setUsername] = useState('Guest');
  const ref = useRef(null);

  useEffect(() => {
    if (isLoggedIn) {
      const token = localStorage.getItem('token');
      const payload = token ? parseJwt(token) : null;
      setUsername(payload?.username || 'User');
    } else {
      setUsername('Guest');
    }
  }, [isLoggedIn]);

  useEffect(() => {
    function onDocClick(e) { if (ref.current && !ref.current.contains(e.target)) setOpen(false); }
    function onEsc(e) { if (e.key === 'Escape') setOpen(false); }
    document.addEventListener('click', onDocClick);
    document.addEventListener('keydown', onEsc);
    return () => { document.removeEventListener('click', onDocClick); document.removeEventListener('keydown', onEsc); };
  }, []);

  return (
    <div className="usermenu" ref={ref}>
      <button className="usermenu-btn" onClick={() => setOpen(v => !v)} aria-haspopup="menu" aria-expanded={open}>
        <span className="avatar" aria-hidden>👤</span>
        <span className="uname">{isLoggedIn ? username : 'Guest'}</span>
        <span className="chev">▾</span>
      </button>

      {open && (
        <div className="usermenu-menu" role="menu">
          {!isLoggedIn ? (
            <button className="usermenu-item" onClick={() => { setOpen(false); onLoginClick(); }} role="menuitem">
              {t('Login')}
            </button>
          ) : (
            <>
              <div className="usermenu-head">{username}</div>
              <button className="usermenu-item" onClick={() => { setOpen(false); onChangePassword(); }} role="menuitem">
                {t('change_password')}
              </button>
              <button className="usermenu-item danger" onClick={() => { setOpen(false); onLogout(); }} role="menuitem">
                  {t('logout')}
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
}
